import { http } from './request';
import type {
  Plan,
  PlanWithQuota,
  Subscription,
  UsageSummary,
  QuotaCheckResult,
  UpgradeRequest,
  DowngradeRequest,
  RecordUsageRequest,
  Invoice,
  PaymentOrder,
} from '../types/subscription';
import type { ApiResponse } from '../types/api';

// 订阅相关 API
export const subscriptionApi = {
  // 获取版本列表
  getPlans: () =>
    http.get<Plan[]>('/api/v1/subscription/plans'),

  // 获取当前订阅
  getCurrentSubscription: () =>
    http.get<Subscription>('/api/v1/subscription/current'),

  // 获取版本对比
  comparePlans: () =>
    http.get<PlanWithQuota[]>('/api/v1/subscription/compare'),

  // 升级版本
  upgrade: (data: UpgradeRequest) =>
    http.post<Subscription>('/api/v1/subscription/upgrade', data),

  // 降级版本
  downgrade: (data: DowngradeRequest) =>
    http.post<Subscription>('/api/v1/subscription/downgrade', data),

  // 获取用量汇总
  getUsageSummary: () =>
    http.get<UsageSummary[]>('/api/v1/usage/summary'),

  // 检查配额
  checkQuota: (metric: string) =>
    http.get<QuotaCheckResult>(`/api/v1/usage/check/${metric}`),

  // 记录用量（内部API）
  recordUsage: (data: RecordUsageRequest) =>
    http.post<{ recorded: boolean }>('/api/v1/usage/record', data),

  // 账单相关
  getBills: (params?: { page?: number; page_size?: number; billing_month?: string }) =>
    http.get<{ list: Invoice[]; total: number }>('/api/v1/billing/bills', { params }),

  getBillDetail: (id: string) =>
    http.get<Invoice>(`/api/v1/billing/bills/${id}`),

  // 支付相关
  createPaymentOrder: (data: { amount: number; subject: string; payment_method: string; invoice_id?: string }) =>
    http.post<PaymentOrder>('/api/v1/payment/create-order', data),

  queryPaymentOrder: (orderNo: string) =>
    http.get<PaymentOrder>(`/api/v1/payment/order/${orderNo}`),
};

export default subscriptionApi;
